class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.tz = this.dataset.shopTimezone || 'Europe/Berlin';
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const now = new Date();
    const todayStr = now.toLocaleDateString('en-CA', { timeZone: this.tz });
    const tomorrowParts = todayStr.split('-').map(Number);
    const tomorrow = new Date(tomorrowParts[0], tomorrowParts[1] - 1, tomorrowParts[2] + 1);

    const nowInTz = new Date(
      now.toLocaleString('en-US', { timeZone: this.tz })
    );
    const diff = Math.max(0, tomorrow - nowInTz);

    const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
    const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');

    this.textContent = `${h}:${m}:${s}`;

    if (diff <= 0) {
      clearInterval(this.interval);
      window.location.reload();
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
